"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTags = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
/**
 * Fetches a list of tags.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/tags/list`
 *
 * @returns Returns a list of tags.
 */
async function getTags(registryBase, repo, username, password, pageSize = 1000, maxPages = Number.MAX_SAFE_INTEGER, options = {}, callChainObserver = { visitedUrls: [] }) {
    const endpoint = `/${repo}/tags/list`;
    return await (0, registry_call_1.paginatedV2Call)(registryBase, contentTypes.JSON, username, password, endpoint, "tags", pageSize, maxPages, options, callChainObserver);
}
exports.getTags = getTags;
//# sourceMappingURL=get-tags.js.map